import {
  ButtonNormalPrimarySmall,
  ButtonWrapper,
} from '@ferreri/prever-component-lib';

import { SETTINGS } from '../../config/settings';

type PlanVersionGsadminButtonProps = {
  planVersionId: string;
};

export const PlanVersionGsadminButton = (
  props: PlanVersionGsadminButtonProps,
) => {
  const redirectToCreateOrder = () => {
    window.location.assign(
      `${SETTINGS.public.urlOrderWeb}/simulate-order/${props.planVersionId}`,
    );
  };

  return (
    <ButtonWrapper onClick={redirectToCreateOrder}>
      <ButtonNormalPrimarySmall>Simular agora</ButtonNormalPrimarySmall>
    </ButtonWrapper>
  );
};
